import Icons from './Icons';
import { useRef, useEffect } from 'react';

export const Accordion = ({ title, children, setOpenedAccordions, openedAccordions, id }) => {
  const open = openedAccordions.includes(id);

  const accordionRef = useRef(null);
  const content = useRef(null);
  const innerContent = useRef(null);

  const accordionToggle = () => {
    if (open) {
      setOpenedAccordions(openedAccordions.filter(accordion => accordion !== id));
    } else {
      setOpenedAccordions([...openedAccordions, id]);

      content.current.setAttribute('style', `--max-height: ${innerContent.current.offsetHeight}px`);
    }
  }

  const onOpenAccordionEvent = (event) => {
    const { detail } = event;

    if (detail.name === title && !open) {
      setOpenedAccordions([...openedAccordions, id]);

      content.current.setAttribute('style', `--max-height: ${innerContent.current.offsetHeight}px`);
      setTimeout(() => {
        // Check if accordion is inside a drawer
        const drawerContainer = accordionRef.current?.closest('.drawer__inner-content-wrapper');
        
        if (drawerContainer) {
          // Inside a drawer - scroll the drawer container
          // const drawerHeader = drawerContainer.querySelector('.drawer__header');
          // const headerHeight = drawerHeader?.offsetHeight || 0;
          const accordionTop = accordionRef.current.offsetTop;
          const scrollPosition = accordionTop;
          
          drawerContainer.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
          });
        } else {
          // Not in a drawer - use regular scrollIntoView
          accordionRef.current.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 210);
    }
  }

  useEffect(() => {
    window.addEventListener('open-accordion', onOpenAccordionEvent);

    return () => {
      window.removeEventListener('open-accordion', onOpenAccordionEvent);
    }
  },[]);

  return (
    <div className="filter-accordion" ref={accordionRef}>
      <input
        className={`filter-accordion__checkbox ${open ? 'filter-accordion__checkbox--open' : ''}`}
        type="checkbox"
        id={id}
        checked={open}
        onChange={accordionToggle}
      />
      <label className="filter-accordion__title" htmlFor={id}>
        <span className="filter-accordion__title-text">{title}</span>

        <span className="filter-accordion__icon">
          {!open ?
            <Icons icon='plus' />
            :
            <Icons icon='minus' />
          }
        </span>
      </label>

      <div className="filter-accordion__content" ref={content}>
        <div className="filter-accordion__content-inner" ref={innerContent}>{children}</div>
      </div>
    </div>
  );
}
